// extracted by mini-css-extract-plugin
export var cta = "blockUploadForm-module--cta--mlexq";
export var help = "blockUploadForm-module--help--TqwJJ";